module.exports = __webpack_public_path__ + "img/hzjg2.8ddaf920.png";